<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">两区活动</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="commonTabContent e-flex">
        <div class="commonTabCenter e-flex">
          <div v-for="(item, index) in tabs" :class="'commonTab ' + (index == tabIndex ? 'commonTabActive' : '')" @click="changeTab(item, index)">{{ item.name }}</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;">
        <div class="tra_listContent">
            <div class="e-flex tra_list" v-for="(item, index) in list">
                <div v-for="val in 5" v-if="list[index * 5 + val - 1]" @click="goDetailPD(list[index * 5 + val - 1].id)" :class="'tra_listBlock ' + (val != 0 ? 'tra_listBlockLeft20' : '')">
                    <div class="tra_listBlockImgContent">
                        <img class="tra_listBlockImg" :src="list[index * 5 + val - 1].thumbUrl">
                        <div class="tra_listBlockDate">{{ list[index * 5 + val - 1].startTime }}</div>
                        <div :class="'trad_activityStatusList ' + ('trad_activityStatus' + list[index * 5 + val - 1].process)">{{list[index * 5 + val - 1].process == 0 ? '未开始' : (list[index * 5 + val - 1].process == 1 ? '已开始' : '已结束')}}</div>
                    </div>
                    <div class="e-flex tra_listBlockCommonContent">
                        <div class="tra_listBlockCommon e-line-2">{{ list[index * 5 + val - 1].title }}</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="noDataContent" v-if="list.length == 0">
        <img class="noDataImg" src="@/assets/images/noDataImg.png">
        <div class="noDataText">暂无内容</div>
      </div>
      <div class="e-flex pd_paginationContent">
        <el-pagination background layout="prev, pager, next, jumper" :page-size="20" :total="pageTotal" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/twoRegionActivity.css'
    export default {
      name: 'twoRegionActivity',
      data () {
        return {
          tabs: [{
            name: '全部分类',
            id: ''
          }],
          tabIndex: 0,
          page: 1,
          categoryId: '',
          list: [],
          pageTotal: 0
        }
      },
      created() {
        this.getCategory()
        this.getActiveList()
      },
      methods: {
        changeTab(item, index) {
          this.tabIndex = index
          this.categoryId = item.id
          this.getActiveList()
        },
        pageChange(e) {
          this.page = e
        },
        goDetailPD(id) {
          this.$router.push({ path: '/twoRegionActivity/detail', query: {id: id}})
        },
        getCategory() {
          this.request({
              url: 'activity/activityCategoryList?page=1&limit=100',
              method: 'get',
              data: {}
          }).then(res => {
              this.tabs = this.tabs.concat(res.data)
          })
        },
        getActiveList() {
          this.request({
              url: 'activity/list?page=' + this.page + '&limit=20&categoryId=' + this.categoryId,
              method: 'get',
              data: {}
          }).then(res => {
              this.list = res.data
              this.pageTotal = res.recordsTotal
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/twoRegionActivity/index.vue